// Constantes tarifaires partagées — SOURCE DE VÉRITÉ de l'offre affichée.
//
// TyCopro est vendu en OFFRE UNIQUE : 9,50 € TTC par mois et par LOT PRINCIPAL
// (appartement, maison, local commercial). Les lots secondaires — caves, garages,
// parkings, celliers — ne sont pas facturés.
//
// La facturation est ANNUELLE. Le prix mensuel unitaire est un mode d'expression du
// tarif, jamais un mode de prélèvement : les pages affichent le total à l'année.
//
// Plancher : la facturation démarre à 4 lots principaux. Une copropriété de 2 ou 3
// lots paie donc le même montant qu'une copropriété de 4 lots.

// Prix unitaire mensuel TTC, par lot principal.
export const MONTHLY_PER_LOT = 9.5;

// Nombre minimum de lots facturés.
export const MIN_LOTS_BILLED = 4;

// Modèle de coût d'un syndic professionnel : FORFAIT DE BASE + honoraires au lot.
//
// C'est la structure réelle d'un mandat de syndic. Le forfait couvre les
// prestations incompressibles quelle que soit la taille de la copropriété :
// tenue de la comptabilité, convocation et tenue de l'AG, obligations légales,
// assurance RCP. Les honoraires au lot s'y ajoutent au-delà du seuil de
// facturation.
//
// Calage : une petite copropriété au seuil de facturation revient à 2 000 € TTC
// par an, valeur constatée sur le marché.
const PRO_BASE_YEAR = 2000;

// Honoraires annuels par lot au-delà du seuil, en €/lot/an.
//
// 240 €/lot/an correspond au BAS de la fourchette réellement observée : une fois
// intégrés les frais annexes (prestations hors forfait, frais de mutation, envois,
// vacations), le coût médian se situe plutôt autour de 300 €/lot/an. Combiné au
// forfait, ce modèle donne 266 €/lot/an pour une copropriété de 40 lots : on reste
// donc sous la médiane, et l'économie annoncée garde une marge de sécurité.
//
// Ces valeurs servent UNIQUEMENT à calculer une économie. Le tarif d'un syndic
// professionnel n'est affiché nulle part sur le site.
const PRO_PER_LOT_YEAR_BASIS = 240;

// Nombre de lots réellement facturés (plancher appliqué sous MIN_LOTS_BILLED).
export function billableLots(lots) {
    const n = Math.floor(Number(lots) || 0);
    return Math.max(MIN_LOTS_BILLED, n);
}

// Coût annuel TTC pour un nombre de lots principaux donné.
export function annualPriceForLots(lots) {
    return billableLots(lots) * MONTHLY_PER_LOT * 12;
}

// Coût annuel d'un syndic professionnel. Usage interne : sert de base aux économies
// affichées, jamais présenté tel quel au visiteur.
//
// Forfait de base, puis honoraires pour chaque lot au-delà du seuil de facturation.
// Le forfait croissant PLUS VITE que l'abonnement TyCopro (240 € contre 114 € par
// lot et par an), l'économie affichée est strictement croissante : elle ne peut
// jamais reculer quand on ajoute un lot au simulateur.
export function proAnnualForLots(lots) {
    const extraLots = Math.max(0, Math.floor(Number(lots) || 0) - MIN_LOTS_BILLED);
    return PRO_BASE_YEAR + extraLots * PRO_PER_LOT_YEAR_BASIS;
}

// Formatage monétaire FR (entier, TTC).
export function formatEUR(n) {
    if (n == null || Number.isNaN(n)) return "—";
    return `${Math.round(n).toLocaleString("fr-FR")} €`;
}

// Formatage FR avec deux décimales — réservé au prix unitaire (9,50 €).
export function formatEURDecimal(n) {
    if (n == null || Number.isNaN(n)) return "—";
    return `${n.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
}
